<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div class="h-inputLit">{{$t('Pm.measureCycle')}}</div>
        <div class="e-input-group e-control-wrapper">
          <ejs-dropdownlist id='timeCycleOfNoRealQuery' :dataSource='dataSourceOfCycle' :fields='fieldsOfCycle' v-model="meterTimePeriod" :change='timeCycleChange'></ejs-dropdownlist>
        </div>
      </div>
      <div id="lastSearch" class="col-sm-6 h-col-inputBox" style='display: none;'>
        <div class="h-inputLit">{{$t('Pm.queryScope')}}</div>
        <ejs-radiobutton :label='$t("Pm.dataLatest")' name="queryType" value= 0 :checked="true" :change="rangeRadioChangeOfQueryType"></ejs-radiobutton>
        <ejs-radiobutton :label='$t("Pm.neLatest")' name="queryType" value= 1 :change="rangeRadioChangeOfQueryType"></ejs-radiobutton>
      </div>
    </div>
    <div class="row h-row-inputBox" v-if="timeFlag">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t('Pm.timeRange')}}</div>
        <ejs-radiobutton :label='$t("Pm.today")' name="timeOfSearch" value="0" :checked="true" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
        <ejs-radiobutton :label='$t("Pm.yesterday")' name="timeOfSearch" value="1" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
        <ejs-radiobutton :label='$t("Pm.currentWeek")' name="timeOfSearch" value="2" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
        <ejs-radiobutton :label='$t("Pm.lastWeek")' name="timeOfSearch" value="3" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
        <ejs-radiobutton :label='$t("Pm.specified")' name="timeOfSearch" value="4" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
        <ejs-radiobutton :label='$t("Pm.latest")' name="timeOfSearch" value="5" :change="rangeRadioChangeOfCycle"></ejs-radiobutton>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <form id="QueryDialog2">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.start_time')}}</div>
          <ejs-datetimepicker :change='validateOfQueryDialog' :locale='locale' name='startTimeOfQueryDialog' :format='dateFormat' :enabled='startTimeEnabled' v-model='meterBegTime'></ejs-datetimepicker>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.end_time')}}</div>
          <ejs-datetimepicker :change='validateOfQueryDialog' :locale='locale' name='endTimeOfQueryDialog' :max='maxDateOfQueryEndTime' :format='dateFormat' :enabled='endTimeEnabled' v-model='meterEndTime'></ejs-datetimepicker>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import DateUtil from '../../../util/DateUtil';

export default {
  name: 'NoRealQuerySearchDialog2',
  props: [
    'timeCycles',
    'kewWordsOfSort'
  ],
  components: {
  },
  data() {
    return {
      timeFlag : true,
      argsValue : '0',
      maxDateOfQueryEndTime: new Date(2100, 11, 31),
      startTimeEnabled: false,
      endTimeEnabled: false,
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      timePeriodCycle: '0',
      queryType: 0,
      meterTimePeriod: 2,
      meterBegTime: new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`),
      meterEndTime: new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`),
      keyWordOfSort: '5',
      dataSourceOfCycle: [{}],
      locale: localStorage.getItem('locale'),
      fieldsOfCycle: {
        value: 'value',
        text: 'text'
      },

      dataSourceOfkeyWordSort: [],
      fieldsOfkeyWordSort: { value: 'sortKey', text: 'sortKeyName' },
      list: [],
      idOfSort: 0,
      formObjOfQueryDialog: '',
      optionsOfQueryDialogValidation: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          startTimeOfQueryDialog: {
            required: [true, `${this.$t('Pm.begTimeNull')}`],
            regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, `${this.$t('Pm.begTimeFormatError')}`]
          },
          endTimeOfQueryDialog: {
            required: [true, `${this.$t('Pm.endTimeNull')}`],
            regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, `${this.$t('Pm.endTimeFormatError')}`]
          }
        }
      }
    };
  },
  methods: {
    timeCycleChange(args) {
      if(args.value <= 8){
        this.timeFlag = true;
        this.rangeRadioChangeOfCycleValue(this.argsValue);
      }else{
        this.timeFlag = false;
        this.rangeRadioChangeOfCycleValue('4');
      }
    },
    rangeRadioChangeOfCycle(args) {
      this.argsValue = args.value;
      this.rangeRadioChangeOfCycleValue(args.value);
    },
    rangeRadioChangeOfCycleValue(value) {
      switch (value) {
        case '0':
          this.timePeriodCycle = '0';
          this.setTodayBeginTime();
          this.setTodayEndTime();
          this.startTimeEnabled = false;
          this.endTimeEnabled = false;
          document.getElementById('lastSearch').style.display = 'none';
          break;
        case '1':
          this.timePeriodCycle = '0';
          this.setYesterdayBeginTime();
          this.setYesterdayEndTime();
          this.startTimeEnabled = false;
          this.endTimeEnabled = false;
          document.getElementById('lastSearch').style.display = 'none';
          break;
        case '2':
          this.timePeriodCycle = '0';
          this.setCurrentWeekBeginTime();
          this.setCurrentWeekEndTime();
          this.startTimeEnabled = false;
          this.endTimeEnabled = false;
          document.getElementById('lastSearch').style.display = 'none';
          break;
        case '3':
          this.timePeriodCycle = '0';
          this.setLastWeekBeginTime();
          this.setLastWeekEndTime();
          this.startTimeEnabled = false;
          this.endTimeEnabled = false;
          document.getElementById('lastSearch').style.display = 'none';
          break;
        case '4':
          this.timePeriodCycle = '0';
          this.meterBegTime = '';
          this.meterEndTime = '';
          this.startTimeEnabled = true;
          this.endTimeEnabled = true;
          document.getElementById('lastSearch').style.display = 'none';
          break;
        case '5':
          this.timePeriodCycle = '1';
          this.meterBegTime = '';
          this.meterEndTime = '';
          this.startTimeEnabled = false;
          this.endTimeEnabled = false;
          document.getElementById('lastSearch').style.display = 'block';
          break;
        default:
      }
    },
    rangeRadioChangeOfQueryType(args) {
      this.queryType = args.value;
    },
    setTodayBeginTime() {
      this.meterBegTime = new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`);
    },
    setTodayEndTime() {
      this.meterEndTime = new Date(`${DateUtil.getTomorrowYearMonthDay()} 00:00:00`);
    },
    setYesterdayBeginTime() {
      this.meterBegTime = new Date(`${DateUtil.getYesterdayYearMonthDay()} 00:00:00`);
    },
    setYesterdayEndTime() {
      this.meterEndTime = new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`);
    },
    setCurrentWeekBeginTime() {
      this.meterBegTime = new Date(`${DateUtil.getCurrentWeekBeginYearMonthDay()} 00:00:00`);
    },
    setCurrentWeekEndTime() {
      this.meterEndTime = new Date(`${DateUtil.getNextWeekBeginYearMonthDay()} 00:00:00`);
    },
    setLastWeekBeginTime() {
      this.meterBegTime = new Date(`${DateUtil.getLastWeekBeginYearMonthDay()} 00:00:00`);
    },
    setLastWeekEndTime() {
      this.meterEndTime = new Date(`${DateUtil.getCurrentWeekBeginYearMonthDay()} 00:00:00`);
    },
    // 执行表单校验
    validateOfQueryDialog() {
      const formStatus = this.formObjOfQueryDialog.validate();
      if (!formStatus) {
        return false;
      }
      return true;
    },

    // 绑定表单校验
    bindValidateOfQueryDialog() {
      this.formObjOfQueryDialog = new FormValidator('#QueryDialog2', this.optionsOfQueryDialogValidation);
    },
  },
  mounted() {
    this.setTodayBeginTime();
    this.setTodayEndTime();
    this.startTimeEnabled = false;
    this.endTimeEnabled = false;
    this.meterTimePeriod = 2;
    this.bindValidateOfQueryDialog();
  },
  watch: {
    timeCycles(timeCycles) {
      this.dataSourceOfCycle = timeCycles;
    },
    kewWordsOfSort(keyWordsOfSort) {
      this.dataSourceOfkeyWordSort = keyWordsOfSort;
      this.keyWordOfSort = keyWordsOfSort[0].sortKey;
    },
    timePeriodCycle(msg) {
      if (msg == '1') {
        this.formObjOfQueryDialog.removeRules()
        this.formObjOfQueryDialog.reset();
      } else {
        this.formObjOfQueryDialog.addRules('startTimeOfQueryDialog', {
          required: [true, this.$t('Pm.begTimeNull')],
          regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, `${this.$t('Pm.begTimeFormatError')}`]
        });
        this.formObjOfQueryDialog.addRules('endTimeOfQueryDialog', {
          required: [true, this.$t('Pm.endTimeNull')],
          regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, `${this.$t('Pm.endTimeFormatError')}`]
        });
      }
      this.formObjOfQueryDialog.validate();
    }
  }
};
</script>

<style>

</style>
